module.exports = __webpack_public_path__ + "static/media/fees-icon.3edb7a41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/fees-icon.svg
// module id = 701
// module chunks = 0